import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import PropTypes from "prop-types";
import "leaflet.bezier";
import "snapsvg-cjs";

import TruckLeft from "assets/images/FreightIcons/TruckLeft.png";
import TruckRight from "assets/images/FreightIcons/TruckRight.png";
import ShipRight from "assets/images/FreightIcons/ShipRight.png";
import ShipLeft from "assets/images/FreightIcons/ShipLeft.png";
import TrainLeft from "assets/images/FreightIcons/TrainLeft.png";
import TrainRight from "assets/images/FreightIcons/TrainRight.png";
import plane from "assets/images/plane.png";

function FlightBezier({ coords, status, freightModeType }) {
  const map = useMap();

  const [curve, setCurve] = useState(null);
  const [icon, setIcon] = useState(null);

  const isOriginLeft = coords.origin[1] < coords.destination[1];

  const renderPath = () => {
    switch (freightModeType) {
      case "air":
        setCurve("8");
        setIcon(plane);
        break;
      case "road":
        setCurve("1");
        setIcon(isOriginLeft ? TruckRight : TruckLeft);
        break;
      case "parcel":
        setCurve("8");
        setIcon(plane);
        break;
      case "ocean":
        setCurve("1");
        setIcon(isOriginLeft ? ShipRight : ShipLeft);
        break;
      case "rail":
        setCurve("1");
        setIcon(isOriginLeft ? TrainRight : TrainLeft);
        break;
      default:
        setCurve("1");
        setIcon(isOriginLeft ? TruckRight : TruckLeft);
    }
  };

  const setFlightPercentage = (status) => {
    let percentage = 0;
    switch (status) {
      case "In transit":
        percentage = 0.5;
        break;
      case "Delayed":
        percentage = 0.1;
        break;
      default:
        percentage = 0.5;
        break;
    }
    return percentage;
  };

  const dash_straight = {
    color: "rgb(145, 146, 150)",
    fillColor: "rgb(145, 146, 150)",
    dashArray: 8,
    opacity: 0.8,
    weight: "1",
    iconTravelLength: setFlightPercentage(status),
    iconMaxWidth: 20,
    iconMaxHeight: 20,
    fullAnimatedTime: 7000,
    easeOutPiece: 4,
    easeOutTime: 2500,
  };

  useEffect(() => {
    renderPath();
  }, []);

  useEffect(() => {
    if (!curve || !icon) return;
    if (freightModeType !== "air" && freightModeType !== "parcel") return;
    L.bezier(
      {
        path: [
          [
            { lat: coords.origin[0], lng: coords.origin[1], slide: "RIGHT_ROUND", deep: curve },
            { lat: coords.destination[0], lng: coords.destination[1] },
          ],
        ],
        icon: {
          path: status === "Delivered" || status === "Booked" || status === "Incomplete" ? null : icon,
        },
      },
      dash_straight,
    ).addTo(map);
  }, [icon, curve]);
  return null;
}

FlightBezier.propTypes = {
  coords: PropTypes.shape({
    origin: PropTypes.arrayOf(PropTypes.number),
    destination: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  status: PropTypes.string,
  freightModeType: PropTypes.string,
};

FlightBezier.defaultProps = {
  status: "",
  freightModeType: "",
};

export default FlightBezier;
